import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import useUniqueId from '../../../util/useUniqueId.js';
import { DropdownListItemV1 } from './DropdownListItemV1.js';
import { DropdownListV2 } from './DropdownListV2.js';

var _excluded = ["items", "type"],
  _excluded2 = ["items"];

/**
 * DropdownList is still in beta stage, some of the functionality is not yet completed.
 */
var DropdownList = function DropdownList(_ref) {
  var items = _ref.items,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var transformList = /*#__PURE__*/React.createElement(React.Fragment, null, items);
  return /*#__PURE__*/React.createElement(DropdownListV2, _extends({
    items: transformList,
    enableArrowKeyFocusNavigationOnPopover: type === 'multiple'
  }, props));
};
var DropdownListMigrationAdapter = function DropdownListMigrationAdapter(_ref2) {
  var _rest$listItemCompone;
  var items = _ref2.items,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var ListItemFactory = (_rest$listItemCompone = rest.listItemComponent) !== null && _rest$listItemCompone !== void 0 ? _rest$listItemCompone : DropdownListItemV1;
  var formName = useUniqueId();
  var newItems = items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(ListItemFactory, {
      item: item,
      key: item.key,
      type: rest.type,
      formName: formName,
      onChange: function onChange(selection) {
        return rest.onChange({
          index: idx,
          item: selection
        });
      }
    });
  });
  return /*#__PURE__*/React.createElement(DropdownList, _extends({
    items: newItems
  }, rest));
};
DropdownList.displayName = 'DropdownList';

export { DropdownList, DropdownListItemV1, DropdownListMigrationAdapter };
//# sourceMappingURL=DropdownList.js.map
